/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_h as h,
} from "../../runtime/index.jsx";
export function Componente_is_105_115(e) {
  let t = (0, ReactCompiler.c)(22),
    { texto: n, detalle: r, onDone: i, duracion: a, posicion: o } = e,
    s = (o === void 0 ? `centro` : o) === `arriba`,
    c = a ?? (s ? 1400 : 1800),
    l,
    u;
  (t[0] !== c || t[1] !== i
    ? ((l = () => {
        let e = setTimeout(i, c);
        return () => clearTimeout(e);
      }),
      (u = [i, c]),
      (t[0] = c),
      (t[1] = i),
      (t[2] = l),
      (t[3] = u))
    : ((l = t[2]), (u = t[3])),
    (0, React.useEffect)(l, u));
  let f = `pointer-events-none fixed inset-0 z-[70] flex justify-center p-6 ${s ? `items-start pt-[max(1.5rem,env(safe-area-inset-top))]` : `items-center`}`,
    p = `celebracion flex flex-col items-center gap-3 rounded-3xl bg-(--bg)/95 text-center shadow-[var(--sombra-flotante)] ring-1 ring-(--border) ${s ? `px-6 py-4` : `px-8 py-7`}`,
    m = s ? `h-12 w-12` : `h-20 w-20`,
    _,
    v;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((_ = (
        <circle
          className={`celebracion-anillo`}
          cx={`36`}
          cy={`36`}
          r={`32`}
          fill={`none`}
          stroke={`var(--success)`}
          strokeWidth={`3`}
          strokeLinecap={`round`}
        />
      )),
      (v = (
        <path
          className={`celebracion-check`}
          d={`M22 37.5 L32 47 L51 27`}
          fill={`none`}
          stroke={`var(--success)`}
          strokeWidth={`5`}
          strokeLinecap={`round`}
          strokeLinejoin={`round`}
        />
      )),
      (t[4] = _),
      (t[5] = v))
    : ((_ = t[4]), (v = t[5]));
  let y;
  t[6] === m
    ? (y = t[7])
    : ((y = (
        <svg
          viewBox={`0 0 72 72`}
          className={m}
          aria-hidden={`true`}
          children={[_, v]}
        />
      )),
      (t[6] = m),
      (t[7] = y));
  let b;
  t[8] === n
    ? (b = t[9])
    : ((b = (
        <p className={`text-base font-medium text-(--text-h)`} children={n} />
      )),
      (t[8] = n),
      (t[9] = b));
  let x;
  t[10] === r
    ? (x = t[11])
    : ((x = r && (
        <p className={`mt-0.5 max-w-xs text-sm text-(--text)`} children={r} />
      )),
      (t[10] = r),
      (t[11] = x));
  let S;
  t[12] !== b || t[13] !== x
    ? ((S = <div children={[b, x]} />), (t[12] = b), (t[13] = x), (t[14] = S))
    : (S = t[14]);
  let C;
  t[15] !== S || t[16] !== p || t[17] !== y
    ? ((C = <div className={p} children={[y, S]} />),
      (t[15] = S),
      (t[16] = p),
      (t[17] = y),
      (t[18] = C))
    : (C = t[18]);
  let w;
  return (
    t[19] !== C || t[20] !== f
      ? ((w = (0, h.createPortal)(
          <div
            className={f}
            role={`status`}
            aria-live={`polite`}
            children={C}
          />,
          document.body,
        )),
        (t[19] = C),
        (t[20] = f),
        (t[21] = w))
      : (w = t[21]),
    w
  );
}
